"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_native_1 = require("react-native");
var native_1 = __importDefault(require("styled-components/native"));
exports.BackdropOverlay = native_1.default(react_native_1.View)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tposition: absolute;\n  bottom: 0;\n  height: 100%;\n  width: 100%;\n  background-color: rgba(0,0,0,0.5);\n"], ["\n\tposition: absolute;\n  bottom: 0;\n  height: 100%;\n  width: 100%;\n  background-color: rgba(0,0,0,0.5);\n"])));
exports.Backdrop = function (_a) {
    var children = _a.children, modalVisible = _a.modalVisible, handleClose = _a.handleClose;
    var animation = new react_native_1.Animated.Value(0);
    var handleOpen = function () {
        react_native_1.Animated.timing(animation, {
            toValue: 1,
            duration: 400,
            useNativeDriver: true
        }).start();
    };
    var renderModal = function () { return (react_1.default.createElement(react_native_1.Modal, { transparent: true, visible: modalVisible, animationType: 'fade', onShow: handleOpen, onRequestClose: handleClose },
        react_1.default.createElement(exports.BackdropOverlay, null,
            react_1.default.createElement(react_native_1.Animated.View, { style: {
                    flex: 1,
                    translateY: animation.interpolate({
                        inputRange: [0, 1],
                        outputRange: [react_native_1.Dimensions.get('screen').height, 0]
                    })
                } }, children)))); };
    return (react_1.default.createElement(react_native_1.View, null, modalVisible && renderModal()));
};
var templateObject_1;
